import { compareStrings } from '../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { ContentControlDataProtectionRule } from '@nirvana/shared/dtos/types/policies/common';
import { getLabelByRuleType } from '../../../../../../utils/uiSettings/contentControl/content-control.values';

// sort by column type
export function sortByColumn(
  item1: ContentControlDataProtectionRule,
  item2: ContentControlDataProtectionRule,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.TYPE:
      return compareStrings(getLabelByRuleType(item1.type), getLabelByRuleType(item2.type), direction);

    case ColumnKeys.NAME:
      return compareStrings(item1.name, item2.name, direction);
    case ColumnKeys.STRING:
      return compareStrings(item1.string, item2.string, direction);
  }

  return 0;
}
